import { render, staticRenderFns } from "./EmptyBox.vue?vue&type=template&id=4621e73a&scoped=true&"
import script from "./EmptyBox.vue?vue&type=script&lang=js&"
export * from "./EmptyBox.vue?vue&type=script&lang=js&"
import style0 from "./EmptyBox.vue?vue&type=style&index=0&id=4621e73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4621e73a",
  null
  
)

export default component.exports